import React, { useState } from "react";
import { IClient } from "../../../../common/interfaces/IClient";
import IQuoteCardResult from "../../../interfaces/results/IQuoteCardResult";
import ViewBreakdownModal from "../../Modals/ViewBreakdownModal/ViewBreakdownModal";
import cx from "classnames";

interface IHeaderBreakdownProps {
    card: IQuoteCardResult;
    clients: IClient[];
    hasDiscountApplied: boolean;
    className?: string;
}

const HeaderBreakdown: React.FC<IHeaderBreakdownProps> = (props) => {
    const { card, clients, hasDiscountApplied, className } = props;

    const [isOpenViewBreakdownModal, setIsOpenViewBreakdownModal] = useState(false);

    return (
        <React.Fragment>
            <ViewBreakdownModal
                isOpen={isOpenViewBreakdownModal}
                onClose={() => setIsOpenViewBreakdownModal(false)}
                settings={card.result.settings}
                card={card}
                clients={clients}
            />
            <div
                className={cx([
                    "layout-flex-column",
                    "layout-quote-breakdown",
                    { [className]: !!className },
                    "gap-m"
                ])}>
                <a
                    className="text-breakdown-link text-semi-bold"
                    onClick={() => setIsOpenViewBreakdownModal(true)}>
                    Price breakdown
                </a>
                {hasDiscountApplied && <div className="text-disclaimer">Discount Applied</div>}
            </div>
        </React.Fragment>
    );
};

export default HeaderBreakdown;
